import React from 'react';
import AppleStoreImage from '../../../assets/appStore.png';
import GooglePlayStoreImage from '../../../assets/googleStore.png';
import {Button} from '@mui/material';

type Props = {
  downloadURL: string;
  store: 'google' | 'apple';
};

export default function DownloadStoreButton(props: Props) {
  const {downloadURL, store} = props;
  const imageToDisplay =
    store === 'apple' ? AppleStoreImage : GooglePlayStoreImage;

  return (
    <Button
      style={styles.buttonStyle}
      onClick={() => window.open(downloadURL, '_blank')}
      disableRipple={true}>
      <img src={imageToDisplay} alt={`${store} image`} style={styles.image} />
    </Button>
  );
}

const styles = {
  buttonStyle: {
    margin: 0,
    padding: 0,
    backgroundColor: 'transparent',
    marginBottom: 50,
    marginTop: 20,
  },
  image: {
    width: 180,
    paddingRight: 10,
  },
};
